import Vue from "vue";

const allModules = require.context("./", true, /\.(js)$/i);
var rules = function() {
  var result = {};
  allModules.keys().forEach(function(mod) {
    if (mod != "./index.js") {
      const file = mod
        // Remove the path of the file
        .replace(/^.*[\\\/]/, "")
        // Remove the extension of the file
        .replace(/\.[^/.]+$/, "");
      // Put the result in the rules object (we don't want to include "default" in the object)
      result[file] = allModules(mod).default;
    }
  });
  return result;
};

function find(str) {
  if (!str) {
    return;
  }
  const elem = str.split(".");
  var current = rules();
  for (var i = 0; i < elem.length; i++) {
    if (!current[elem[i]]) {
      return;
    }
    current = current[elem[i]];
  }
  return current;
}

export function gatherRules(...args) {
  var result = [];
  args.forEach(arg => {
    result = result.concat(find(arg));
  });
  return result;
}

Vue.prototype.$rules = gatherRules;
